export default function(error) {
    if (error.message && error.message.includes("timeout")) {
        return "нестабильное соединение, попробуйте позже с хорошим Интернетом!"
    }
    return error;
}
